import { axios } from '@Root/API'

export const getAll = (courseSessionId, params) => {
	return axios.get(`get/supervisor-allocation/student-course-session/${courseSessionId}`, { params })
}

